import { lazy } from 'react'
import ReceivedInvoicesLoader from './received-invoices/loader'
import StatementsLoader from './statements/loader'
import EditSupplierStatementLoader from './statements/edit/loader'
import AddStatementLoader from './statements/add/loader'
import AccountingSystemExportLoader from './statements/accounting-system-export/loader'
import ExportToLoader from './statements/export-to/loader'
import StockOnHandLoader from './stock-on-hand/loader'

export default {
  ReceivedInvoices: {
    Component: lazy(() => import('./received-invoices/ReceivedInvoices.Page')),
    Loader: ReceivedInvoicesLoader,
  },
  Statements: {
    Component: lazy(() => import('./statements/Statements.Page')),
    Loader: StatementsLoader,

    EditSupplierStatement: {
      Component: lazy(
        () => import('./statements/edit/EditSupplierStatement.Page')
      ),
      Loader: EditSupplierStatementLoader,
    },
    AddSupplierStatement: {
      Component: lazy(
        () => import('./statements/add/AddSupplierStatement.Page')
      ),
      Loader: AddStatementLoader,
    },
    AccountingSystemExport: {
      Component: lazy(
        () =>
          import(
            './statements/accounting-system-export/AccountingSystemExport.Page'
          )
      ),
      Loader: AccountingSystemExportLoader,
    },
    ExportTo: {
      Component: lazy(() => import('./statements/export-to/ExportTo.Page')),
      Loader: ExportToLoader,
    },
  },
  StockOnHand: {
    Component: lazy(() => import('./stock-on-hand/StockOnHand.Page')),
    Loader: StockOnHandLoader,
  },
}
